var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-select",
    _vm._b(
      {
        staticClass: "form-control",
        staticStyle: { "min-width": "220px" },
        attrs: { options: _vm.options },
        on: { change: _vm.handleChange },
        scopedSlots: _vm._u([
          {
            key: "first",
            fn: function() {
              return [
                _c("b-form-select-option", { attrs: { value: null } }, [
                  _vm._v("\n      Injeção Gradual\n    ")
                ])
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.selectedGradualInjection,
          callback: function($$v) {
            _vm.selectedGradualInjection = $$v
          },
          expression: "selectedGradualInjection"
        }
      },
      "b-form-select",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }